import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map, timeout} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {ConfigService} from '@services/infra/config.service';
import {UploadDocument} from '@services/resource/upload-document';
import {UploadDocumentType} from '@services/resource/upload-document-type';
import {ErrorService} from '@services/error.service';

export const TWO_MINUTES = 120000;

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  constructor(
    private readonly http: HttpClient,
    private readonly conf: ConfigService,
    private readonly errors: ErrorService,
  ) {}

  public create(file: File, docType: UploadDocumentType, productId: string): Observable<UploadDocument> {
    const url = `${this.conf.backendUrl}/v1/document`;
    const doc = JSON.stringify(new UploadDocument(file.name, docType, productId));

    const payload = new FormData();

    payload.append('documentResource', new Blob([doc], {type: 'application/json'}));
    payload.append('attachment', file);
    return this.http.post<UploadDocument>(url, payload, {withCredentials: true}).pipe(
      timeout(TWO_MINUTES),
      this.errors.withErrorHandler(),
      map((w) => w),
    );
  }
}
